module.exports = __webpack_public_path__ + "static/media/ball-usd.5981b311.svg";